const env = {
  OPEN_API:
    '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',
  HEYGEN_API: 'ZDY5YmM1ZDliMzUwNGIwOTk3YzJiYzFlZWQyMDRiYjMtMTczMzY4NjUwNA==', // prod,
  HEYGEN_TOKEN:
    'eyJ0b2tlbiI6ICJlMjE4NmU3OTM5MTc0MzYwYjJlZmM4NGU2MGU2MmRiOCIsICJ0b2tlbl90eXBlIjogInNhX2Zyb21fcmVndWxhciIsICJjcmVhdGVkX2F0IjogMTczODI2MTcxNn0=',
  HEYGEN_SERVER: 'https://api.heygen.com',
  ELEVEN_LAB_API: 'sk_04bf0f28cc640380fe4ae9d48d8cf9e0aaf9022e2fe21e89', //'sk_b1ca404a653497053b793578008f89565adfbdd367ae7655',
  PLAYAI_USERID: 'LHjBJ9nvzCdjrNvYaXdgbbXy0Xg2', //'SQQgzFBWOZQZEKVM5bQmc74N0rV2',
  PLAYAI_SECRETKEY: '84b2376f00db473bbfa459e7abf9f74e', //'ak-179cb656d8ec422f8952043a14e69d05',
  RETELL_API: 'key_dfea59ea741e0b4813a1919eab90',
  SYNTHFLOW_API: '1722726881047x649059610768157800',
}

export default env
